import React from "react";
import * as style from "./style.module.scss";

type Props = {
    children: React.ReactNode;
};

const VerticalLayout = ({ children }: Props) => {
    return <div className={style.container}>{children}</div>;
};

export default VerticalLayout;
